(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-v2-sales-assurance-item"] && !Shopify.designMode) return;
  try {
    (function () {
    var PC_MIN = 1184;

    function getClipEl(bubble) {
      return bubble.closest('.swiper');
    }

    function clipBounds(clipEl) {
      var margin = 8;
      if (clipEl) {
        var cr = clipEl.getBoundingClientRect();
        return { left: cr.left + margin, right: cr.right - margin };
      }
      return { left: margin, right: window.innerWidth - margin };
    }

    function resetBubbleLayout(bubble) {
      bubble.style.transform = '';
      bubble.style.removeProperty('--pv2-sa-arrow-left');
    }

    function cancelDeferredReset(bubble) {
      var st = bubble._pv2saReset;
      if (!st) return;
      clearTimeout(st.timer);
      bubble.removeEventListener('transitionend', st.onTransitionEnd);
      bubble._pv2saReset = null;
    }

    /**
     * 等 opacity 消失过渡结束再清 transform，否则会闪现「未校准」位置。
     */
    function deferResetLayoutUntilHidden(bubble) {
      cancelDeferredReset(bubble);
      var st = {};
      st.onTransitionEnd = function (e) {
        if (e.propertyName !== 'opacity') return;
        cancelDeferredReset(bubble);
        resetBubbleLayout(bubble);
      };
      bubble.addEventListener('transitionend', st.onTransitionEnd);
      st.timer = setTimeout(function () {
        cancelDeferredReset(bubble);
        resetBubbleLayout(bubble);
      }, 220);
      bubble._pv2saReset = st;
    }

    /**
     * 相对 Swiper（或视口）贴边纠正水平位移；倒三角用 --pv2-sa-arrow-left 对准 ro_tip 中心。
     */
    function layoutBubble(bubble, trigger) {
      var clipEl = getClipEl(bubble);
      var bounds = clipBounds(clipEl);

      bubble.style.transform = 'translateX(-50%)';
      var totalShift = 0;
      var iter;
      for (iter = 0; iter < 8; iter++) {
        var br = bubble.getBoundingClientRect();
        var delta = 0;
        if (br.right > bounds.right) delta -= br.right - bounds.right;
        if (br.left < bounds.left) delta += bounds.left - br.left;
        if (delta === 0) break;
        totalShift += delta;
        bubble.style.transform = 'translateX(calc(-50% + ' + totalShift + 'px))';
      }

      var tr = trigger.getBoundingClientRect();
      var brFinal = bubble.getBoundingClientRect();
      var iconCx = tr.left + tr.width / 2;
      var arrowX = iconCx - brFinal.left;
      var inset = 10;
      arrowX = Math.max(inset, Math.min(brFinal.width - inset, arrowX));
      bubble.style.setProperty('--pv2-sa-arrow-left', arrowX + 'px');
    }

    document.querySelectorAll('.pv2-sa-tooltip').forEach(function (tooltip) {
      var trigger = tooltip.querySelector('.pv2-sa-tooltip-trigger');
      var bubble = tooltip.querySelector('.pv2-sa-tooltip-bubble');
      if (!trigger || !bubble) return;

      tooltip.addEventListener('mouseenter', function () {
        if (window.innerWidth < PC_MIN) return;
        cancelDeferredReset(bubble);
        layoutBubble(bubble, trigger);
      });

      tooltip.addEventListener('mouseleave', function () {
        if (window.innerWidth < PC_MIN) return;
        deferResetLayoutUntilHidden(bubble);
      });

      trigger.addEventListener('click', function (e) {
        if (window.innerWidth >= PC_MIN) return;
        e.stopPropagation();
        var isOpen = bubble.classList.contains('is-open');
        document.querySelectorAll('.pv2-sa-tooltip-bubble.is-open').forEach(function (b) {
          b.classList.remove('is-open');
          deferResetLayoutUntilHidden(b);
        });
        if (!isOpen) {
          cancelDeferredReset(bubble);
          bubble.classList.add('is-open');
          requestAnimationFrame(function () {
            layoutBubble(bubble, trigger);
          });
        }
      });
    });

    document.addEventListener('click', function (e) {
      if (e.target.closest('.pv2-sa-tooltip')) return;
      document.querySelectorAll('.pv2-sa-tooltip-bubble.is-open').forEach(function (b) {
        b.classList.remove('is-open');
        deferResetLayoutUntilHidden(b);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["section-appear"] && !Shopify.designMode) return;
  try {
    (() => {
    if (!window.IntersectionObserver || !Element.prototype.animate) return;

    const appearSelector = '[data-section-appear]';
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    const appearObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;

        appearObserver.unobserve(entry.target);
        if (reducedMotion.matches) return;

        entry.target.animate(
          [
            { opacity: 0, transform: 'translateY(20%)' },
            { opacity: 1, transform: 'translateY(0)' }
          ],
          { duration: 800, easing: 'ease-out' }
        );
      });
    });

    function initAppear(root) {
      root.querySelectorAll(appearSelector).forEach((element) => appearObserver.observe(element));
    }

    initAppear(document);
    document.addEventListener('shopify:section:load', (event) => initAppear(event.target));
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll(appearSelector).forEach((element) => appearObserver.unobserve(element));
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
